import { roles } from '@/config/roles'

const routes = [
  {
    name: 'ClassStudents',
    path: '/class/student/list',
    component: () => import('@/views/class/Students.vue'),
    meta: {
      roles: [roles.teacher, roles.curator, roles.admin]
    }
  },
  {
    name: 'ClassEvents',
    path: '/class/content/events',
    component: () => import('@/views/class/Events.vue'),
    meta: {
      roles: [roles.teacher, roles.student, roles.curator]
    }
  },
  {
    name: 'ClassPage',
    path: '/class/content/class-page/:gpClass',
    component: () => import('@/views/class/Page.vue'),
    meta: {
      roles: [roles.teacher, roles.student]
    }
  },
  {
    name: 'ClassEvent',
    path: '/class/content/events/:id',
    component: () => import('@/views/class/Event.vue'),
    meta: {
      roles: [roles.teacher, roles.student, roles.curator]
    }
  }
]
export default routes
